import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgArrowRight = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.68955 3.35617C8.89782 3.14788 9.23551 3.14788 9.44379 3.35617L13.7105 7.62283C13.9187 7.83111 13.9187 8.1688 13.7105 8.37707L9.44379 12.6438C9.23551 12.852 8.89782 12.852 8.68955 12.6438C8.48126 12.4355 8.48126 12.0978 8.68955 11.8894L12.0458 8.53329H2.66667C2.37212 8.53329 2.13333 8.2945 2.13333 7.99995C2.13333 7.7054 2.37212 7.46662 2.66667 7.46662H12.0458L8.68955 4.11041C8.48126 3.90213 8.48126 3.56444 8.68955 3.35617Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgArrowRight)
const IconSvgArrowRight = createIcon(ForwardRef, 'SvgArrowRight')
export default IconSvgArrowRight
